'use scrict';

export const initNojs = () => {
  if (document.querySelector('.no-js')) {
    document.querySelector('.no-js').classList.remove('no-js');
  }
}
